import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import * as braze from '@braze/web-sdk';

require("./styles/index.scss");
require("./../node_modules/bootstrap/scss/bootstrap.scss");

braze.initialize(process.env.VUE_APP_BRAZE_API_KEY, { baseUrl: process.env.VUE_APP_BRAZE_SDK, enableLogging: false });

const app = createApp(App);
app.use(store).use(router).mount('#app');
app.config.globalProperties.$braze = braze;

